import { z } from 'zod';
import type { HistoryEmployeeReportFilterI } from 'types';

/**
 * Esquema de validación para los filtros del reporte de cursos de un empleado.
 * Incluye campos para búsqueda por nombre del curso y fecha de asignación.
 */
export const historyEmployeeReportFilterSchema = z.object({
  name: z.string().optional(),
  assignedAt: z.string().optional(),
});

/**
 * Valores predeterminados para los filtros del reporte de cursos de un empleado.
 */
export const defaultValue: HistoryEmployeeReportFilterI = {
  name: '',
  assignedAt: undefined,
};
